/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { config } from "../../../../utils/config";
import { currencyFormatter } from "../../../../utils/currency";
import Button from '../../elements/button';
import { errorTrackingGaEvent } from "../../../../utils/analytics/google";
import './index.scss';
import { useAddAccessoryMutation } from "../../../../store/newCart";
import { startLoading } from "../../../../store/application";
import i18n from '../../../../utils/translations/i18n';
import { logSentryTransacation } from "../../../../utils/sentry";
import cartActions from '../../../../store/cartActions';
import { LineItemType } from '../../../../enums/lineItemType';

declare const window: any;

const ProductAccessory = ({ cart, lineItemId, productAccessory }) => {
    const dispatch = useDispatch();
    const { t } = i18n;
    const mainItem: any = cart.lineItems[lineItemId][0].data;
    const [addAccessory] = useAddAccessoryMutation();
    const [error, setError] = useState(Object());
    const [val, setVal] = useState({});

    useEffect(() => {
        setVal(resetFields(productAccessory));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart])

    const resetFields = (productAccessory) => {
        const defaultAccessory = {}
        productAccessory?.forEach(accessory => {
            defaultAccessory[accessory?.id] = ''
        })
        return defaultAccessory;
    }

    const validateValue = (value) => {
        if (value === '') {
            return '';
        } else if (Number(value) < 1) {
            return { message: `${t('shopping_cart_details.minValueError')} ${1}.`, messageGA: t('shopping_cart_details.minValueError_GA') }
        } else if (Number(value) > 5000) {
            return { message: `${t('shopping_cart_details.maxValueError')} ${5000}.`, messageGA: t('shopping_cart_details.maxValueError_GA') }
        } else {
            return '';
        }
    }

    const handleInputChange = (event) => {
        const input = event.target.value.replace(/\D/g,'');
        const id = event.target.id;
        const status = validateValue(input);
        status === '' ? setError({}) : setError({ id: id, message: status.message, messageGA: status.messageGA });
        setVal({ ...val, [id]: input });

        // show add btn oninput
        if(input) {
            document.getElementsByClassName(id)[0]?.classList.add('showBtn');
        } else {
            document.getElementsByClassName(id)[0]?.classList.remove('showBtn');
        }
    }

    const clickHandler = async (event) => {
        const id = event.target.id
        const accessoryVal = val[id]

        if (accessoryVal === '') {
            setError({ id: id, message: t('shopping_cart_details.noValueError'), messageGA: t('shopping_cart_details.noValueError_GA') });
        }
        else if (accessoryVal < 1) {
            setError({ id: id, message: `${t('shopping_cart_details.minValueError')} ${1}.`, messageGA: `${t('shopping_cart_details.minValueError_GA')}` });
        }
        else if (accessoryVal > 5000) {
            setError({ id: id, message: `${t('shopping_cart_details.maxValueError')} ${5000}.`, messageGA: `${t('shopping_cart_details.maxValueError_GA')}` });
        }
        else {
            const transaction = logSentryTransacation("addAccessory");
            const addedAcc = productAccessory.find((addAcc) => addAcc.id === id);
            dispatch(startLoading());
            await addAccessory({cartId: cart.id,mainItemId : mainItem.id,quantity : accessoryVal,productKey : addedAcc.productKey,variantId : addedAcc.variantId,accessoryId : addedAcc.id});
            transaction?.finish();
        }
    }

    const addErrorClass = (accessoryId: any) => {
        return (error.message !== '' && error.id === accessoryId) ? 'errorClass' : '';
    }

    const isMacSafariAndIphonebelowVer14 = window.np?.isMacSafariAndIphoneVerBelow14();

    function getAccessoryQty(id: string) {
        const addedAccessory = productAccessory.find((addAccessory) => addAccessory?.id === id);
        const accessoryAlreadyPresent = cart.lineItems[mainItem.id].find((item) => item?.data?.productId === addedAccessory?.id);
        return accessoryAlreadyPresent?.data?.quantity;
    }

    function removeAccessory(id: string) {
        const addedAccessory = productAccessory.find((addAccessory) => addAccessory?.id === id);
        const addedAccessoryData = cart.lineItems[mainItem.id].find((item) => item?.data?.productId === addedAccessory?.id);
        dispatch(cartActions.removeLineItem(addedAccessoryData?.data?.id, LineItemType.ACCESSORY, cart, mainItem.id));
    }

    return (
        productAccessory?.map((accessory) => {
            const accessoryQty = getAccessoryQty(accessory.id);
            if (config('locale') === 'sk-SK') accessory.name = accessory.name.toLowerCase();
            const accessoryImageUrl = window.np?.compressImageURL(accessory.imageUrl, 154, 154, isMacSafariAndIphonebelowVer14);
            const addTranslation = t('shopping_cart_details.add_text');
            const sizeClassByTextLength = addTranslation.length <= 5 ? 'sml-btn' : addTranslation.length <= 7 ? 'mid-btn' : 'lrg-btn';

            return (
                <li className="accessoryListItems" key={accessory.id} data-accid={accessory.id} data-accessoryvariantid={accessory.variantId}>
                    <div className={`extra-items__elem ${sizeClassByTextLength}`}>

                        {config('locale') === 'ja-JP' ?
                            <>
                                <a href="#" onClick={e => e.preventDefault()} className="extra-items__image-link">
                                    {accessory.name}
                                    <img alt="" src={accessoryImageUrl} className="extra-items__img" />
                                </a>
                            </> :
                            <>
                                <a href="#" onClick={e => e.preventDefault()} className="extra-items__image-link">
                                    {accessory.name}
                                    <img src={accessoryImageUrl} className="extra-items__img" alt="" />
                                </a>
                            </>
                        }

                        {!accessoryQty ? 
                            <div className="accessoryAmount">
                                <span> @ {currencyFormatter(accessory.unitPrice, cart.fractionDigits)} {t('shopping_cart_details.accQtyEachLabel')} </span>
                            </div> : <div className="remove-acc" onClick={()=>removeAccessory(accessory.id)} >{t('shopping_cart_details.removeButton')}</div>
                        }

                        {(error.message !== '' && error.id === accessory.id) &&
                            <div className="acc-qty-error">
                                {error.message}
                                {errorTrackingGaEvent('cart', error.messageGA)}
                            </div>
                        }
                    </div>

                    {!accessoryQty ? 
                        <div className="extra-items__quantity">
                            <input id={accessory.id} className={`extra-quantity ${(document.getElementById(accessory.id) as HTMLInputElement)?.value && 'showLabel'} ${addErrorClass(accessory.id)} ${sizeClassByTextLength}`} type="number" onChange={handleInputChange} value={val[accessory.id] || ''} placeholder={t('shopping_cart_details.accQtyLabel')} maxLength={5}/>
                            <Button className={`addAccBtn ${accessory.id} ${sizeClassByTextLength}`} onClick={clickHandler} children={addTranslation} id={accessory.id} />
                            {(document.getElementById(accessory.id) as HTMLInputElement)?.value && <label className="qtyLabel">{t('shopping_cart_details.accQtyLabel')}</label>}
                        </div> : <div className="quantityContainer">{t('shopping_cart_details.accQtyLabel')}: {accessoryQty} {t('header.logo_imprint_added')}</div>
                    }
                </li>
            );
        })
    );
}

export default ProductAccessory;